module.exports = __webpack_public_path__ + "img/VICKI-HERMO.bce9ca1a.jpg";